import React, { useContext, useEffect } from 'react'
import { connect } from 'react-redux'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import HotelsTabContent from './HotelsTabContent'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

interface MappedStateProps {
  selectedTravellerEmployeeIds?: Array<string>
  selectedTravellerGuestCount?: number
}

interface Props {
  onSearch: () => void
}

function HotelTabContentComponent(props: Props & MappedStateProps) {
  const { onSearch, selectedTravellerEmployeeIds, selectedTravellerGuestCount } = props

  const globalSearchDispatch = useContext(GlobalSearchDispatchContext)
  const globalSearchState = useContext(GlobalSearchStateContext)

  useEffect(() => {
    if (selectedTravellerEmployeeIds && selectedTravellerGuestCount !== undefined) {
      // Only set occupancies if they haven't been set yet (or are at default)
      // This prevents overwriting multi-room occupancies that were already configured
      const currentOccupancies = globalSearchState.occupancies
      const hasMultipleRooms = currentOccupancies && currentOccupancies.length > 1

      if (!hasMultipleRooms) {
        globalSearchDispatch({ type: GlobalSearchStateActions.SET_OCCUPANCIES, occupancies: [{ adults: (selectedTravellerEmployeeIds.length + selectedTravellerGuestCount) || 1 }] })
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalSearchDispatch])

  return (<HotelsTabContent onSearch={onSearch} />)
}

export default connect<MappedStateProps, undefined, undefined, App.State>((appState) => {
  return {
    selectedTravellerEmployeeIds: appState.businessTraveller.selectedTravellerEmployeeIds,
    selectedTravellerGuestCount: appState.businessTraveller.selectedTravellerGuestCount,
  }
})(HotelTabContentComponent)
